export const AdminSalesDashboards = {
  AdminSalesDashboards: 
  {
    permissionsId:'2927e262-852d-434e-ee3c-08da65738802',
    permissionsName:'Admin Sales' , 
    componentsId:null,
    components:null
  }
} ;
